import styled from 'styled-components'
import { createTheme } from '@material-ui/core/styles'
import { makeStyles } from '@mui/styles'

export const SettingWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .log {
    margin-top: -2px;
  }
  .privacy-nature {
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      margin-left: -65px;
    }
  }
  .log-data {
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      margin-left: 22px;
    }
  }
  .profile {
    display: flex;
    justify-content: space-between;
    width: 80%;
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
  }
  .list-flex {
    display: flex;
    align-items: center;
  }

  .setitems {
    padding-left: 18px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-left: 10px;
    }
  }
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.navyBlue};
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 140%;
    color: ${({ theme }) => theme.colors.profileBlack};
    margin-top: -10px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: 8px;
    }
  }
  .profileimg {
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      order: 1;
      justify-content: center;
    }
  }
  .profileImage {
    width: 80%;
  }
  .profileTexts {
    @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
      order: 4;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    @media (max-width: 900px) {
      width: 90%;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
      margin-top: 0px;
    }
  }
  .title {
    @media (max-width: 1100px) {
      padding-left: 30px;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      padding-left: 0px;
    }
  }
  .link {
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
    }
  }
`

export const Wrapper = styled.div`
  .upload {
    position: relative;
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-left: -30px;
    }
  }
  img {
    max-width: 150px !important;
    height: 150px;
  }

  .item {
    width: 150px;
    height: 150px;
    float: left;
    margin: 3px;
    padding: 3px;
    .profileImage {
      margin-top: 40px;
      width: 95%;
      height: 419px;
    }
  }

  .upload img {
    border-radius: 50%;
    border: 6px solid #eaeaea;
  }
  .width {
    width: 15%;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  .upload-photo {
    width: 132px;
    height: 132px;
  }

  .upload .round {
    position: absolute;
    /* bottom: 170px;
    right: 30px; */
    background: transparent;
    width: 150px;
    /* opacity: 9; */
    /* visibility: hidden; */
    height: 150px;
    line-height: 33px;
    text-align: center;
    border-radius: 50%;
    /* margin-bottom: -40px; */
    /* display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center; */
    overflow: hidden;
    /* z-index: -20; */
  }

  .upload .round input[type='file'] {
    position: absolute;
    transform: scale(2);
    opacity: 0;
    width: 100%;
    /* -webkit-transform-origin-z: 1000; */
    z-index: 1;
  }

  input[type='file']::-webkit-file-upload-button {
    cursor: pointer;
    width: 150px;
    height: 150px;
  }
  .item .profileImage {
    margin-top: 40px;
    width: 150px;
    height: 150px;
    margin-top: -10px;
  }
  .upload .round input[type='file'] {
    position: absolute;
    -webkit-transform: scale(2);
    -ms-transform: scale(2);
    transform: scale(2);
    opacity: 0;
    width: 150px;
    z-index: 1;
  }
  .username {
    margin-left: 30px;
    margin-top: -10px;
    h2 {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${({ theme }) => theme.colors.navyBlue};
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        font-size: 18px;
      }
    }
  }
`

export const theme = createTheme({
  spacing: 4,
})

export const useStyles = makeStyles({
  root: {
    background: '#FAF3EC',
    width: 'auto',
    position: 'absolute',
    top: 'calc(50% - 240px)',
    left: 'calc(40% - 160px)',
  },
  formImage: {
    boxShadow: '0 0 10px',
    backgroundColor: 'white',
    width: '500px',
    height: '500px',
    display: 'flex',
    flexWrap: 'wrap',
    // border-radius:'15px 15px 15px 15px',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '25ch',
  },
  divForm: {
    width: '90%',
  },
  image: {
    width: '90%',
    height: '35%',
    margin: '8px',
  },
  paperRoot: {
    maxWidth: 345,
  },
})
